import { render, staticRenderFns } from "./VacationRequestsAdmin.vue?vue&type=template&id=59b96b07&scoped=true&"
import script from "./VacationRequestsAdmin.vue?vue&type=script&lang=js&"
export * from "./VacationRequestsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./VacationRequestsAdmin.vue?vue&type=style&index=0&id=59b96b07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b96b07",
  null
  
)

export default component.exports